import { CandidateEmailComponent } from './../../candidate/candidate-email/candidate-email.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TalentpoolService } from './../../_services/talentpool.service';
import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { CandidateService } from 'src/app/_services/candidate.service';
import { CreateTalentpoolComponent } from '../create-talentpool/create-talentpool.component';
import { TransactionService } from '../../_services/transaction.service';
import { Router } from '@angular/router';

declare const clevertap;


@Component({
    selector: 'app-add-to-talentpool',
    templateUrl: './add-to-talentpool.component.html',
    styleUrls: ['./add-to-talentpool.component.scss'],
    standalone: false
})
export class AddToTalentpoolComponent implements OnInit {

  talentpoolslist: any[] = [];
  talentpoolname: string = '';
  confirmation_message: string;
  talentpoolnumber: any;
  success_message: string;
  noTalentpoolError: boolean;
  subscriptiondetails: any = {};

  @Input() candidatetoAdd: any;
  @Input() BuldCandidatetoAdd: any[];
  @Input() type;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  @Input() calledFrom: String = ''
  @Input() profileurlsarray: any = [];
  @ViewChild('confirmationModal') confirmationModal: TemplateRef<any>
  @ViewChild('errorModal') errorModal: TemplateRef<any>
  @ViewChild('successModal') successModal: TemplateRef<any>
  @ViewChild('noCreditTalentpool') noCreditTalentpool: TemplateRef<any>;
  errorMessage: any;

  @ViewChild('trigger') matAutocompleteTrigger: any;

  @ViewChild('requestCredit') requestCredit: TemplateRef<any>;

  @Input() uiChange: any = false;
  talentpools: any
  talentpoolerrormsg: string = '';
  addToTalentpoolSpinner: boolean = false;
  hideCreateTalentpool: boolean = false;

  // ======= variables for showing flow post adding candidate ====
  addCandidateCompleted = false;
  addCandidateSuccess = false;
  candidatesAddedCount = 0;
  postTPAddMssg: string = null;
  @Input() lastSelectedCandidateName:string;
  confirmationDialog: NgbModalRef = null;
  talentpoolId: string = null;
  // ===============================================================


  private resetPostTPAdd() {
    this.addCandidateCompleted = false;
    this.addCandidateSuccess = false;
    this.candidatesAddedCount = 0;
    this.postTPAddMssg = null;
  }

  constructor(private router: Router,public talentpoolservice: TalentpoolService, public modalService: NgbModal,
    private _localstorageservice : LocalStorageService,
    private candidateService : CandidateService,
    private transactionservice: TransactionService
    ) { }

  ngOnInit() {
    this.getAllTalentpool();
  }

  async getAllTalentpool(event = null){
    const result = await this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber')).toPromise();
    const talentPoolData = result.status == "success" ? result.data : result;
    this._localstorageservice.setItem('talentPoolDetails', JSON.stringify(talentPoolData));
    if (talentPoolData && Object.keys(talentPoolData).length) {
        this.talentpoolslist = talentPoolData.talentpools.filter((x) =>{ return x.name.toLowerCase().includes(this.talentpoolname.toLowerCase()) });
        this.talentpools = this.talentpoolslist;
        let talentpoolFound =  talentPoolData.talentpools.find(x => (x.name == this.talentpoolname));
        if(talentpoolFound == undefined && this.talentpoolname!= ''){
          if(this.calledFrom == 'searchToolBox' && event){
            this.talentpoolslist = []
            this.talentpoolslist.push({
              name: event.target.value,
              notFound: true
            })
          }
        }else{
          this.noTalentpoolError = false
        }
     }
  }

  openConfirmationModal() {
    this.talentpoolerrormsg = '';
    if(this.talentpoolname != '' && this.talentpoolname != null && this.talentpoolname && this.talentpoolname.trim() != '') {
      this.confirmation_message = 'Are you sure you want to add selected candidates to ' + this.talentpoolname + '? ';
      const dialogRef = this.modalService.open(this.confirmationModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      this.confirmationDialog = dialogRef;
    } else {
      this.talentpoolerrormsg = 'Enter talentpool name';
    }
  }

  closeConfirmationDialog() {
    // Note: Not adding null/undefined check here because this should only be called if confirmation dialog is open
    this.confirmationDialog.close();
  }

  closeAddToTPModal() {
    this.modalService.dismissAll();
  }

  addCandidateToTalentpool() {
    this.closeConfirmationDialog();
      this.resetPostTPAdd();
      let candidateobject = [];
      for (let candidate of this.BuldCandidatetoAdd) {
        candidateobject.push({
          candidatenumber: candidate
        })
      }

    let data = {
        talentpoolnumber: this.talentpoolnumber,
        insertobject: candidateobject.length > 0 ? candidateobject :  [{'candidatenumber' :  this.candidatetoAdd.candidatenumber }],
        usernumber: this._localstorageservice.getItem('usernumber')
      }

    this.addToTalentpoolSpinner = true;
    this.talentpoolservice.addCandidatetoTalentpool(data).subscribe((res: any) => {
      this.candidatesAddedCount = candidateobject.length > 0 ? candidateobject.length : 1;
      this.addCandidateCompleted = true;

      this.addToTalentpoolSpinner = false;
      if (res.status == 'success' && res.message != 'Nothing to insert' && res.message != 'TALENT_POOL_LIMIT_EXCEEDED') {
        this.addCandidateSuccess = true;
        // this.modalService.dismissAll()
        // this.passEntry.emit('candidateAdded');
        if (this.candidatesAddedCount === 1) {
          this.postTPAddMssg = `${this.candidateName} added successfully to the ${this.talentpoolname} talentpool`;
        } else if (res?.isPartial) {
          this.postTPAddMssg = `${res.uniqueInsertionLength} candidates have successfully been added to the ${this.talentpoolname} talentpool. There were ${res.insertionRequestLength - res.uniqueInsertionLength} candidates which were already part of ${this.talentpoolname} talentpool.`;
        } else {
          this.postTPAddMssg = `${this.candidatesAddedCount} candidates have successfully been added to the ${this.talentpoolname} talentpool.`;
        }
      }else if(res.message =='Nothing to insert') {
        // this.modalService.dismissAll()
        // this.passEntry.emit('alreadyexist');
        this.postTPAddMssg = 'Candidate already exist in talentpool';
      }else if(res.message =='Missing parameters') {
        // this.modalService.dismissAll()
        // this.passEntry.emit('Missing parameters');
        this.postTPAddMssg = 'Missing parameters';
      } else if (res?.message == 'TALENT_POOL_LIMIT_EXCEEDED') {
        this.postTPAddMssg = 'You can only add up to 2500 candidates.';
      } else {
        // this.modalService.dismissAll()
        // this.passEntry.emit('error');
        this.postTPAddMssg = 'Something went wrong.';
      }
    }, (err) => {
      this.closeConfirmationDialog();
      this.addCandidateCompleted = true;
      this.postTPAddMssg = 'Something went wrong.';
      console.log('err while adding to talent pool... ', err);
    })
  }

  private get candidateName() {
    let res = '';
    if (this.candidatetoAdd && (this.candidatetoAdd.firstname || this.candidatetoAdd.lastname)) {
      if (this.candidatetoAdd.firstname) res += this.capitalizeFirstLetter(this.candidatetoAdd.firstname);
      if (this.candidatetoAdd.lastname) res += ' ' + this.capitalizeFirstLetter(this.candidatetoAdd.lastname);
    } else {
      res = this.lastSelectedCandidateName ? this.lastSelectedCandidateName.split(" ").map(el => this.capitalizeFirstLetter(el)).join(" ") : res;
    }
    return res;
  }

  private  capitalizeFirstLetter(string) {
    if (typeof string !== 'string' || string.length === 0) {
      return '';
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  redirectToTalentPool() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([`/talentpool/details/${this.talentpoolId}`]);
    this.modalService.dismissAll();
  }

  openCreateTalentpool(event, talentpoolData){
    this.talentpoolerrormsg = '';
    const data = {
      name: talentpoolData.name,
      usernumber: this._localstorageservice.getItem('usernumber')
    }
    // if(this._localstorageservice.getItem('tpcredits') > -1){
      this.talentpoolservice.createTalentpool(data).subscribe((result: any) => {
        if(result.status == 'success'){
          this.toastmessage('Talentpool Created Succesfully', 'success')
          if(this.matAutocompleteTrigger){
            this.matAutocompleteTrigger.closePanel()
          }
          this.fetchcredits()
          /**
           * create talentpool from my talentpool
           */
            const talentpoolParams = {
              "User ID": this._localstorageservice.getItem('userdata').userid,
              "Talentpool Name": talentpoolData.name,
              "Number of Candidates": 0,
              "Source": "Search"
            }
            clevertap.event.push('Create Talentpool', talentpoolParams);
          const data = {
            profileurlsarray: this.profileurlsarray,
            talentpoolnumber: result.data.talentpoolnumber,
            talentpoolname: talentpoolData.name,
            talentpoolId: result?.data?.talentpoolid
          }
          this.talentpoolnumber = result.data.talentpoolnumber
          this.talentpoolId = result?.data?.talentpoolid;
          this.passEntry.emit(data)
        }else if (result.status == 'failure' && result.message == 'insufficient credits') {
          this.modalService.dismissAll();
          const modalRef = this.modalService.open(this.noCreditTalentpool,{ centered: true });
          this.sendmailexpiry('Talent Pipeline credits')
        }
      });
    // }else{
    //   const modalRef = this.modalService.open(this.noCreditTalentpool,{ centered: true });
    //   this.sendmailexpiry('Talent Pipeline credits')
    // }
    return event.stopPropagation();
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.success_message = message;
      setTimeout(() => this.success_message = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  cleverTapEvent(eventName, data) {
   // clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }

  fetchcredits() {
    // Credits come from the shared signal (populated only on login and after reveal-contact
    // succeeds, see TransactionService) - no direct call to /paymentflow/fetchcurrentplancredits.
    const res: any = { data: this.transactionservice.credits() };
    if (res.data) {
        if (res.data.isteamadmin) {
          // Here the logged in person is a Team Admin
          this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
          this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
          this.subscriptiondetails.balancejdparsingcredits = res.data.pooledbalancejdparsingcredits;
          this.subscriptiondetails.balancesmartemailcredits = res.data.pooledbalancesmartemailcredits;
          this.subscriptiondetails.balancetalentpipelinecredits = res.data.pooledbalancetalentpipelinecredits;
        } else {
          if (res.data.teamadmindetails) {
            // Here the logged in person is a Team Member
            // this.isteamMember = true
            this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.teamadmindetails.adminbalancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.teamadmindetails.adminbalancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.teamadmindetails.adminbalancetalentpipelinecredits;
          } else {
            // Here the logged in person is a normal (who does not belong to any team)
            this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.balancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.balancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.balancetalentpipelinecredits;
          }
        }
        this.subscriptiondetails.smartemailcredits = res.data.smartemailcredits
        this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancesmartemailcredits)
      }
  }
  sendmailexpiry(type){
    let data ={
      expiredmetric : type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }

  route2pricing() {
    this.modalService.dismissAll()
    if(this._localstorageservice.getItem('isteamMember')){
      this.modalService.open(this.requestCredit, { windowClass: "modalExtract",  centered: true, backdrop: 'static', keyboard: false });
    }else{
      this.router.navigateByUrl('subscription/pricing')
    }
  }

  searchtalentpool(event) {
    this.hideCreateTalentpool  = false
    this.talentpoolerrormsg = '';
    const value = event.target.value;
    this.talentpools = this.talentpoolslist.filter((x) =>{ return x.name.toLowerCase().includes(value.toLowerCase()) });
    if(value !== ''){
      this.talentpools.push({
        name: event.target.value,
        userAdded: true
      })
    }
    if(this.talentpools && this.talentpools.length && this.talentpools[0].name.trim().toLowerCase() == value.trim().toLowerCase() && this.talentpools[0].hasOwnProperty('talentpoolnumber')){
      this.hideCreateTalentpool = true;
      this.talentpools = this.talentpools.filter(x => !x.userAdded === true)
    }

    this.passEntry.emit({ talentpoolname: this.talentpoolname });
  }

  selecttalentpool(talentpool) {
    this.talentpoolerrormsg = '';
    if(this.calledFrom == 'searchToolBox'){
      const data = {
        profileurlsarray: this.profileurlsarray,
        talentpoolnumber: talentpool.talentpoolnumber,
        talentpoolname: talentpool.name,
        talentpoolId: talentpool.talentpoolid
      }
      this.passEntry.emit(data)
    }
    this.talentpoolnumber = talentpool.talentpoolnumber;
    this.talentpoolId = talentpool.talentpoolid ? talentpool.talentpoolid : this.talentpoolId;
  }
}
